import SVG from "@Components/Icons/SVG";
import React from "react";
export default class Tick extends SVG {
    viewbox = "0 0 20 20";
    path = [
        "M 10 0 A 10 10 0 0 1 20 10 A 10 10 0 0 1 10 20 A 10 10 0 0 1 0 10 A 10 10 0 0 1 10 0 Z",
    ];
    checkmarkPath = [
        "M13.3967 6.9271L8.62336 11.5338L7.35669 10.1804C7.12336 9.96043 6.75669 9.9471 6.49003 10.1338C6.23003 10.3271 6.15669 10.6671 6.31669 10.9404L7.81669 13.3804C7.96336 13.6071 8.21669 13.7471 8.50336 13.7471C8.77669 13.7471 9.03669 13.6071 9.18336 13.3804C9.42336 13.0671 14.0034 7.6071 14.0034 7.6071C14.6034 6.99376 13.8767 6.45377 13.3967 6.92043V6.9271Z",
    ];
    fill = "#00A555";
    strokeDetails = {
        stroke: "none",
        strokeWidth: "0",
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };
    evenOdd = true;
    render() {
        const { size, className, rotate, onClick, onMouseOver, onMouseOut } = this.props;
        const style = {};
        if (rotate !== 0) {
            style.transform = `rotate(${rotate}deg)`;
        }
        return (React.createElement("svg", { onClick: onClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut, width: size || "20px", height: size || "20px", viewBox: this.viewbox, style: style, className: className, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "#00A555" }),
            React.createElement("path", { d: this.checkmarkPath.join(" "), fill: "white", fillRule: "evenodd", clipRule: "evenodd" })));
    }
}
